import script from "./EntityFieldSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityFieldSelector.vue?vue&type=script&setup=true&lang=js"

import "./EntityFieldSelector.vue?vue&type=style&index=0&id=3333ef57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3333ef57"]])

export default __exports__